export const UnsupportedManufacturerTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                If using inverters other than our currently supported inverter manufacturers, monitoring integration
                is not yet available.
            </li>
            <li>
                If the manufacturer of your solar inverter isn't currently supported in our integrations, we
                recommend securely providing your monitoring login details to our customer support team for enhanced
                troubleshooting assistance. <span className="font-semibold">Click</span> your avatar in the top
                right-hand corner of the Solar Insure platform, <span className="font-semibold">select
                "Profile"</span> from the dropdown menu, and
                then <span className="font-semibold">go</span> to
                the <span className="font-semibold">"Integrations"</span> tab.
            </li>
            <li>
                <span className="font-semibold">Stay updated</span> on when your manufacturer will be supported by
                checking announcements or <span className="font-semibold">contacting customer service.</span>
            </li>
        </ul>
    </div>
